import { requestApi } from "../axios";

export function getSetting(key, appId) {
  return requestApi(`/admin/setting?key=${key}&partnerAppId=${appId}`, "GET");
}
